import { Box, Button, Flex, Text, VStack, Icon } from '@chakra-ui/react'
import { FiEdit, FiSearch, FiPackage, FiDownload } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'

export function OmniPromo() {
  const { codigo_usuario } = useUser()

  return (
    <Box
      bgImage="url('https://imgproductioncrm.s3.us-east-2.amazonaws.com/backgroud.png1745497955.9329')"
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPosition="center"
      bgColor="#2f3440"
      w="100%"
      h="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="end"
      alignItems="center"
      position="relative"
    >
      <VStack spacing={2} zIndex={1} mb={'28'} textAlign="center" maxW="1366px" px={4}>
        {/* Mensagem de boas-vindas */}
        <VStack mb={10}>
          <Text color="white" fontSize="2xl" fontWeight="bold">
            Bem-vindo ao OmniPromo!
          </Text>

          {/* Subtítulo */}
          <Text color="white" fontSize="lg" mb={10}>
            Registre novos pedidos ou acompanhe o andamento dos pedidos anteriores
          </Text>
        </VStack>

        {/* Botões principais */}
        <Flex gap="20px" wrap="wrap" justifyContent="center" mb={10}>
          <Button
            size="lg"
            leftIcon={<Icon as={FiEdit} />}
            color="#00FF7F"
            border="1px solid #00FF7F"
            borderColor={'#00FF7F'}
            borderRadius="md"
            px={6}
            py={6}
            minW="220px"
            variant="outline"
            as={Link}
            to="/omnipromo/cadastrar-pedido"
            _hover={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _active={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _focus={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
          >
            Cadastrar novo pedido
          </Button>

          <Button
            size="lg"
            leftIcon={<Icon as={FiSearch} />}
            color="#00FF7F"
            border="1px solid #00FF7F"
            borderColor={'#00FF7F'}
            borderRadius="md"
            px={6}
            py={6}
            minW="220px"
            variant="outline"
            as={Link}
            to="/omnipromo/pedidos-em-analise"
            _hover={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _active={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _focus={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
          >
            Pedidos em Análise
          </Button>

          <Button
            size="lg"
            leftIcon={<Icon as={FiPackage} />}
            color="#00FF7F"
            border="1px solid #00FF7F"
            borderColor={'#00FF7F'}
            borderRadius="md"
            px={6}
            py={6}
            minW="220px"
            variant="outline"
            as={Link}
            to="/omnipromo/pedidos-aprovados"
            _hover={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _active={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
            _focus={{
              textDecoration: 'none',
              backgroundColor: '#00FF7F',
              color: 'white',
            }}
          >
            Acompanhar Pedidos
          </Button>

          {/* Botão de download */}
          <Button
            as="a"
            //https://api.innovationbrindes.com.br/api/site/v2/tercerizado/download-tabela-preco-tercerizado
            href={`https://api.innovationbrindes.com.br/api/site/v2/tercerizado/download-tabela-preco-tercerizado?codigo_usuario=${codigo_usuario}`}
            download
            variant="ghost"
            colorScheme="whiteAlpha"
            leftIcon={<Icon as={FiDownload} />}
            color="white"
          >
            Baixar Tabela de Preços
          </Button>
        </Flex>
      </VStack>
    </Box>
  )
}
